// Script para inicializar o tema corretamente
// Este script é executado imediatamente quando o arquivo é carregado

// Função para inicializar o tema
function initializeTheme() {
  try {
    // Definir o tema padrão como 'brand' (Modo Marca)
    const theme = 'brand';
    
    console.log('Inicializando tema fixo:', theme);
    
    // Remover todas as classes de tema primeiro
    document.documentElement.classList.remove('dark', 'light');
    
    // Adicionar a classe do tema marca
    document.documentElement.classList.add('brand');
    
    // Definir o atributo data-theme para CSS personalizado
    document.documentElement.setAttribute('data-theme', theme);
    
    // Salvar o tema no localStorage para garantir consistência
    localStorage.setItem('theme', theme);
    
    console.log('Tema inicializado com sucesso:', theme);
  } catch (error) {
    console.error('Erro ao inicializar o tema:', error);
  }
}

// Executar a inicialização do tema
initializeTheme();

// Adicionar um evento para garantir que o tema seja aplicado quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM carregado, verificando tema...');
  initializeTheme();
});

// Exportar a função para uso em outros componentes se necessário
export { initializeTheme };
